import React from 'react'
import HighlightText from '../HomePage/HighlightText'

const Quote = () => {
  return (
    <div className=" text-xl md:text-4xl font-semibold mx-auto py-5 pb-20 text-center text-white">
      Real Junior is revolutionizing education by integrating ,  <HighlightText text={"tech skills early"} />,{" "}
        <span className="bg-gradient-to-b from-[#FF512F] to-[#F09819] text-transparent bg-clip-text font-bold">
            {" "}
        making learning interactive,
        </span>
      <HighlightText text={"practical"} />, and 
        <span className="bg-gradient-to-b from-[#E65C00] to-[#F9D423] text-transparent bg-clip-text font-bold">
            {" "}
        future-ready for young students.
        </span> 
    </div>
  )
}

export default Quote